import React from "react";

import { FormResources } from "../types/formData";
import { useValuationManagerContext } from "../ValuationManagerContext";

interface Props {
  formResources: FormResources;
}

export const EscalationPage = ({ formResources }: Props) => {
  const { redirectUrl } = useValuationManagerContext();

  return (
    <div className="panel panel-default">
      <div className="panel-heading">{formResources.escalation.title}</div>
      <div className="panel-body">
        <p>
          This valuation has been escalated as we cannot offer an automated
          valuation.
        </p>
        {redirectUrl && (
          <div className="panel-body">
            <a href={redirectUrl} rel="noopener noreferrer">
              <button
                className="btn btn-success"
                data-testid="redirect-button"
                type="button"
              >
                Take me back to Carsanet
              </button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
